
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class ZjhTable extends Vue {
    //炸金花
    table = {
        data: [],
        column: [
            {
                key: 'Bet',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].Bet)
                    return h('span', str)
                }
            },
            {
                key: 'RealAWard',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].RealAWard)
                    return h('span', str)
                }
            },
            {
                key: 'PercentPoin',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].PercentPoin)
                    return h('span', str)
                }
            },
            {
                key: 'end_round',
                title: '轮数',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).end_round
                    return h('span', str)
                }
            },
            {
                key: 'end_round',
                title: '是否看牌',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).is_look ? '是' : '否'
                    return h('span', str)
                }
            },
            {
                key: 'reason',
                title: '结算原因',
                align: 'center',
                render: (h, params) => {
                    let num = JSON.parse(params.row.opt_detail).reason
                    let arr = ['正常结束', '', '主动弃牌', '主动比牌输', '被动比牌输', '孤注一掷比牌输', '正常超时弃牌', '掉线超时弃牌']
                    let str = arr[num]
                    return h('span', str)
                }
            },
            {
                key: 'CompUids',
                title: '比牌对象',
                align: 'center',
                render: (h, params) => {
                    let str = ''
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let arr = strzo[bulidUid(params.row.user_id, strzo)].CompUids || []
                    if (arr) {
                        arr.map((v) => {
                            str += bulidUid(v) + '；'
                        })
                    }
                    return h('span', str)
                }
            },
            {
                key: 'AllinUids',
                title: '全押对象',
                align: 'center',
                render: (h, params) => {
                    let str = ''
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let arr = strzo[bulidUid(params.row.user_id, strzo)].AllinUids
                    if (arr) {
                        arr.map((v) => {
                            str += bulidUid(v) + '；'
                        })
                    }
                    return h('span', str)
                }
            }
        ],
        columnDetail: [
            {
                key: 'game_name',
                title: '玩家1',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    let str = strzo[String(obj[0])].C
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'blue',
                                    marginTop: '2px'
                                }
                            },
                            obj[0] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[0])}(查询玩家)` : bulidUid(obj[0])
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'game_name',
                title: '玩家2',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 1) {
                        let str = strzo[String(obj[1])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[1] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[1])}(查询玩家)` : bulidUid(obj[1])),
                            h('div', {
                                style: {
                                    marginTop: '5px',
                                    position: 'relative',
                                    height: '50px'
                                },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    } else {
                        return h('str', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '玩家3',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 2) {
                        let str = strzo[String(obj[2])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[2] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[2])}(查询玩家)` : bulidUid(obj[2])),
                            h('div', {
                                style: {
                                    marginTop: '5px',
                                    position: 'relative',
                                    height: '50px'
                                },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    } else {
                        return h('str', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '玩家4',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 3) {
                        let str = strzo[String(obj[3])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[3] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[3])}(查询玩家)` : bulidUid(obj[3])),
                            h('div', {
                                style: {
                                    marginTop: '5px',
                                    position: 'relative',
                                    height: '50px'
                                },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    } else {
                        return h('str', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '玩家5',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 4) {
                        let str = strzo[String(obj[4])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[4] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[4])}(查询玩家)` : bulidUid(obj[4])),
                            h('div', {
                                style: {
                                    marginTop: '5px',
                                    position: 'relative',
                                    height: '50px'
                                },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    } else {
                        return h('str', '无')
                    }
                }
            }
        ]
    }

    @Prop()
    listdata
}
